/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {checkToken} from '../../../../../api/modules/auth'
import {useTranslation} from 'react-i18next'
import swal from 'sweetalert'
import {useNavigate} from 'react-router-dom'
import {withProtectedRoute} from '../../../../../utils/withProtectedRoute'
import { TableLog } from './table/TableLog'

const LogSalesOrderWrapper: FC = withProtectedRoute(() => {
  const intl = useIntl()
  const {t} = useTranslation()
  const navigate = useNavigate()

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  useEffect(() => {
    const cektoken = async () => {
      if (localStorage.getItem('token') != undefined) {
        const tempToken = localStorage.getItem('token')
        await checkToken(tempToken?.replace(/['"]+/g, ''))
          .then((res) => {
            if (localStorage.getItem('credential') == undefined)
              localStorage.setItem('credential', res.data.credential)
            const test = atob(res.data.credential)
            const temp = JSON.parse(test)
            localStorage.setItem('accesses', JSON.stringify(res.data.accesses))
            if (temp.role_flag == null)
              localStorage.setItem(
                'username',
                temp.customer?.title != null
                  ? temp.customer?.title + ' ' + temp.customer?.name
                  : temp.customer?.name
              )
            else localStorage.setItem('username', temp.name)
            localStorage.setItem('credential-decoded', test)
            if (temp.customer_code != '' || temp.customer_code != null)
              localStorage.setItem('cust-code', temp.customer_code)

            if (
              temp.customer?.customer_account_group != '' ||
              temp.customer?.customer_account_group != null
            )
              localStorage.setItem('cust-group', temp.customer?.customer_account_group)
          })
          .catch((res) => {
            if (res.response.data.message != 'Token not found' && res.response.data.error == true)
              window.location.reload()
            else if (res.response.data.error) {
              swal({
                title: res.response.data.message,
                icon: 'error',
              }).then(() => {
                removeStorage()
                navigate('/auth')
              })
            }
          })
      } else {
        swal({
          title: t('Token Not Found'),
          timer: 2000,
          icon: 'error',
        }).then(() => {
          removeStorage()
          navigate('/auth')
        })
      }
    }
    cektoken()
  }, [])

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('Log Sales Order')}</PageTitle>
      <TableLog className='card-xxl-stretch mb-5 mb-xl-8' />
    </>
  )
})

export {LogSalesOrderWrapper}
